import style from './Banner.module.scss';

import { FC, HTMLAttributes, AriaAttributes } from 'react';
import clsx from 'clsx';

export enum BannerVariant {
  CLOSED = 'closed',
  ALERT = 'alert',
  INFO = 'info',
  ERROR = 'error'
}

const VARIANT_STYLE_MAP: Record<BannerVariant, string | undefined> = {
  [BannerVariant.CLOSED]: style.closed,
  [BannerVariant.ALERT]: style.alert,
  [BannerVariant.INFO]: style.info,
  [BannerVariant.ERROR]: style.error
};

const VARIANT_ARIA_MAP: Record<BannerVariant, AriaAttributes['aria-live']> = {
  [BannerVariant.CLOSED]: 'polite',
  [BannerVariant.ALERT]: 'polite',
  [BannerVariant.INFO]: 'polite',
  [BannerVariant.ERROR]: 'assertive'
};

type BannerProps = {
  variant: BannerVariant;
  rounded?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const Banner: FC<BannerProps> = ({ children, className, variant, rounded, ...props }) => (
  <div
    className={clsx(style.banner, VARIANT_STYLE_MAP[variant], { [style.rounded]: rounded }, className)}
    aria-live={VARIANT_ARIA_MAP[variant]}
    {...props}
  >
    {children}
  </div>
);
